export enum OpexType {
  INDIRECT = 'indirect',
  DIRECT = 'direct'
}

export enum OpexRelationshipType {
  MONTHLY_OPEX = 'monthly_opex',
  PPE_INDIRECT = 'ppe_indirect', 
  PPE_DIRECT = 'ppe_direct',
}

export interface OpexItem {
  id: number;
  no?: string; // 계층형 순번 (1, 1.1, 1.2, 2, 2.1, 2.1.1 등)
  category: string;
  amount: number; // 원화 기준 금액 (계산용)
  originalAmount?: number; // 입력된 원본 금액
  currency?: 'KRW' | 'USD'; // 통화 타입
  exchangeRate?: number; // 저장 시점의 환율
  note?: string;
  type: OpexType;
  relationshipType: OpexRelationshipType;
  createdAt: Date;
  updatedAt: Date;
  // 계층 구조 지원 필드
  parentId?: number;
  children?: OpexItem[];
  level?: number;
  isCategory?: boolean;
  sortOrder?: number;
  // 3단계 항목용 개수와 단가 필드
  quantity?: number; // 개수
  unitPrice?: number; // 단가
}

export interface MonthlyOpex {
  id: number;
  month: number;
  employeeCount: number;
  confirmed: boolean;
  opexItems: OpexItem[];
  createdAt: Date;
  updatedAt: Date;
}

export interface Year {
  id: number;
  year: number;
  months: MonthlyOpex[];
  createdAt: Date;
  updatedAt: Date;
}

// 프론트엔드에서 사용하는 기존 인터페이스 (호환성 유지)
export interface MonthlyOpexData {
  month: number;
  employeeCount: number;
  confirmed: boolean;
  indirect: OpexItem[];
  direct: OpexItem[];
  exchangeRate?: {
    usdToKrw: number;
    date: string;
    change?: number;
  };
}

export interface YearData {
  year: number;
  months: MonthlyOpexData[];
}

// API 생성용 DTO
export interface CreateOpexItemDto {
  category: string;
  amount: number;
  note?: string;
  type: OpexType;
}

export interface CreateMonthlyOpexDto {
  month: number;
  employeeCount?: number;
  confirmed?: boolean;
  opexItems: CreateOpexItemDto[];
}

export interface CreateYearDto {
  year: number;
  months: CreateMonthlyOpexDto[];
}

export interface UpdateYearDto extends Partial<CreateYearDto> {}